/**
 * Parses a Google Places address result into a standardized format
 * @param addressComponents - Components from Google Places API response
 * @returns Structured address object
 */
export const parseGoogleAddress = (addressComponents) => {
    // Store both long_name and short_name for each type
    const longNames = {};
    const shortNames = {};
    addressComponents.forEach((comp) => {
        comp.types.forEach((type) => {
            longNames[type] = comp.long_name;
            shortNames[type] = comp.short_name;
        });
    });
    const streetNumber = longNames.street_number || '';
    const route = longNames.route || '';
    // subpremise contains floor/unit/apartment/suite numbers from Google Places
    const subpremise = longNames.subpremise || '';
    const city = longNames.locality ||
        longNames.sublocality_level_1 ||
        longNames.administrative_area_level_2 ||
        '';
    // Use short_name for state (e.g., "NY" instead of "New York")
    const state = shortNames.administrative_area_level_1 || '';
    const zipCode = longNames.postal_code || '';
    const streetAddress = [streetNumber, route].filter(Boolean).join(' ').trim();
    return {
        venueName: '',
        streetAddress,
        unit: subpremise,
        city,
        state,
        zipCode
    };
};
//# sourceMappingURL=parser.js.map